<template>
  <div class="dashboard">
    <v-container>
      <dashboardParalex v-if="inf" />
      <InfDB v-if="inf" :settings="settings" />
      <v-layout row wrap>    
        <v-flex xs12 md6 pa-1>
          <v-card>
            <v-card
            color="primary"
            dark
            flat
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">Quick Links</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card-title>
              <v-layout row wrap>
                <v-progress-linear v-if="isLoading" :indeterminate="isLoading"></v-progress-linear>
                <v-flex xs12>
                  <v-list dense>
                    <template v-for="item in items">
                      <v-layout
                        row
                        v-if="item.heading"
                        align-center
                        :key="item.heading"
                      >
                        <v-flex xs6>
                          <v-subheader v-if="item.heading">
                            {{ item.heading }}
                          </v-subheader>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                          <a href="#!" class="body-2 black--text">EDIT</a>
                        </v-flex>
                      </v-layout>
                      <v-list-group
                        v-else-if="item.children"
                        v-model="item.model"
                        :key="item.text"
                        :prepend-icon="item.model ? item.icon : item['icon-alt']"
                        append-icon=""
                      >
                        <v-list-tile slot="activator">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ item.text }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-for="(child, i) in item.children"
                          :key="i"
                          @click="goTo(child.path)"
                        >
                          <v-list-tile-action v-if="child.icon">
                            <v-icon>{{ child.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title  >
                              {{ child.text }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list-group>
                      <v-list-tile v-else @click="goTo(item.path)" :key="item.text">
                        <v-list-tile-action>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ item.text }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 pa-1>
          <v-card>
            <v-card
            color="primary"
            dark
            flat
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">Announcments</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card-title>
              <v-layout row wrap>
                <v-progress-linear v-if="isLoading" :indeterminate="isLoading"></v-progress-linear>
                <v-flex v-for="item in announcments" :key="item.title" xs12 ma-2>
                  <v-card color="primary accent-4" class="white--text">
                    <v-card-title primary-title>
                      <div>
                        <span>{{ item.date }}</span>
                        <div class="headline">{{ item.title }}</div>
                        <span>{{ item.details }}</span>
                      </div>
                    </v-card-title>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import dashboardParalex from '../components/dashboardParalex';
import InfDB from '../components/InfDB';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
const headers = {'Accept': 'application/json'};


export default {
  components:{ dashboardParalex, InfDB },
  data() {
    return {
      settings:{embed:true, home:true},
      announcments:[],
      isLoading:false,
    }
  },
  computed:{
    items() {
      let role =  this.$store.state.role
      return this.$store.state.menu[role]
    },
    role () {
      return this.$store.state.role
    },
    inf(){
      return this.$store.state.inf
    },
    infsite(){
      return this.$store.state.user
    },
  },
  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    async loadAnnouncments(){
      let a = await db.ref('announcments').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.announcments = Object.values(a).map((x, i)=>{
          return {
            ...x,
            date:new Date(x.date).toISOString().split('T')[0],
            key:b[i]
          }
        })
      }
    },
  },

  props: {
   userName: {
    required: true,
    default: 'Green Way'
   },
   userImage: {
    required: true,
    default: ''
   }
  },
  async created() {
    this.loadAnnouncments()
    

  },
  async mounted() {
    



  },
  destroyed() {
    console.log('Component has been destroyed!');
  }
}
</script>

<style>

</style>
